import { Component } from '@angular/core';
import { CurrentUserFlowService } from '@core/services/current-user/current-user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(private currentUserFlowService: CurrentUserFlowService) {
    this.currentUserFlowService.fetchCurrentUserData();
  }
}
